import './index.scss';

import Image from '../../../../assets/images/ft-cad01@2x.png';
import { Link } from 'react-router-dom';

export const AbrirContaAgora = () => {

    return (

        <div className='container-abrir-agora'>
            <div className='container-cnpj-cpf'>
                <h1> Abra agora sua conta </h1>
                <h2> [ Para sua empresa ] </h2>
                <img alt={Image} src={Image} />
                <p>
                    <span style={{ fontWeight: 'bold' }}>Conta pessoa jurídica:</span> tenha assessoria personalizada
                    para seu nicho de atuação. As melhores taxas para câmbio
                    pronto, produtos de crédito e hedge, múltiplas cotações e
                    cashback.
                </p>
                <Link className='btn-style' to="/cadastro-juridico"> Abrir com CNPJ </Link>
            </div>
            <div className='container-cnpj-cpf' style={{ backgroundColor: '#2328B4' }}>
                <h1 style={{opacity:0, userSelect:"none"}}> Abra agora sua conta </h1>
                <h2> [ Para você ] </h2>
                <img alt={Image} src={Image} />
                <p>
                    <span style={{ fontWeight: 'bold' }}> Conta pessoa física:</span> tenha os melhores serviços em
                    transferência de valores para o exterior, câmbio para
                    viagens e intercâmbio, pagamentos de produtos e
                    serviços, recebimento de salários.
                </p>
                <Link className='btn-style' to="/cadastro-fisico"> Abrir com CPF </Link>
            </div>
        </div>

    )

}
